import React from 'react';
import { Badge, Image } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Link, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import classNames from 'classnames';
import y from 'y4/Utils';
import _ from 'lodash';
import noFile from 'assets/img/illustrations/nothing.webp';

const sliderSettings = {
  autoplay: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
};

const ProductSingleImage = ({ id, image, name, layout }) => {
  const params = useParams();
  return (
    <Link
      to={`/${params.corp}/e-commerce/product/product-details/${id}`}
      className="d-block h-sm-100"
      key={id}
    >
      <Image
        rounded={layout === 'list'}
        src={image}
        onError={e => {
          e.target.src = noFile;
        }}
        className={classNames('h-100 w-100 fit-cover', {
          'rounded-top': layout === 'grid'
        })}
        alt={name}
      />
    </Link>
  );
};

const ProductImage = ({ name, id, isNew, files, layout }) => {
  if (y.isEmpty(files)) files = [noFile];
  return (
    <div
      className={classNames('position-relative rounded-top overflow-hidden', {
        'h-sm-100': layout === 'list'
      })}
    >
      {files.length === 1 && (
        <ProductSingleImage
          id={id}
          image={files[0]}
          name={name}
          layout={layout}
        />
      )}
      {files.length > 1 && (
        <Slider
          {...sliderSettings}
          className="slick-slider-arrow-inner h-100 full-height-slider"
        >
          {files.map(image => (
            <ProductSingleImage
              key={image.id}
              id={id}
              image={image}
              name={name}
              layout={layout}
            />
          ))}
        </Slider>
      )}
      {isNew &&
        (_.isPlainObject(isNew) ? (
          <Badge
            pill
            bg={isNew.bg}
            text={isNew.text}
            className="position-absolute top-0 end-0 me-2 mt-2 fs--2 z-index-2"
          >
            {isNew.content}
          </Badge>
        ) : (
          <Badge
            pill
            bg="success"
            className="position-absolute top-0 end-0 me-2 mt-2 fs--2 z-index-2"
          >
            New
          </Badge>
        ))}
    </div>
  );
};

ProductSingleImage.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  layout: PropTypes.string.isRequired
};

ProductImage.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isNew: PropTypes.any,
  files: PropTypes.arrayOf(PropTypes.string),
  layout: PropTypes.string.isRequired
};

export default ProductImage;
